var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import pluralize from 'pluralize';
import { Accordion } from './Accordion';
import { Grades } from '@hn-front/data-types';
var Container = styled.div.withConfig({ displayName: "Container", componentId: "sc-1b1bmdp" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
var Delimiter = styled.span.withConfig({ displayName: "Delimiter", componentId: "sc-31xaai" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: 0 8px;\n"], ["\n  margin: 0 8px;\n"])));
var Text = styled.p.withConfig({ displayName: "Text", componentId: "sc-olowka" })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-size: 16px;\n  line-height: 24px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n"], ["\n  font-size: 16px;\n  line-height: 24px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n"])));
var AddClassHeader = function (_a) {
    var _b;
    var _c = _a.groupInfo, classNumber = _c.number, grade = _c.grade, students = _c.students;
    return (_jsxs(Container, { children: [_jsx(Text, { children: "Mathematics" }, void 0), _jsx(Delimiter, { children: "|" }, void 0), _jsxs(Text, { children: ["Class number ", _jsx("b", { children: classNumber }, void 0)] }, void 0), _jsx(Delimiter, { children: "|" }, void 0), _jsx(Text, { children: (_b = Grades[grade]) === null || _b === void 0 ? void 0 : _b.full }, void 0), _jsx(Delimiter, { children: "|" }, void 0), _jsx(Text, { children: pluralize('student', students, true) }, void 0)] }, void 0));
};
var AddClassAccordion = function (_a) {
    var groupInfo = _a.groupInfo, rest = __rest(_a, ["groupInfo"]);
    return (_jsx(Accordion, __assign({}, rest, { header: _jsx(AddClassHeader, { groupInfo: groupInfo }, void 0), label: 'Add class', checked: true, readonly: true }), void 0));
};
export { AddClassAccordion };
var templateObject_1, templateObject_2, templateObject_3;
